import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachNamApi } from "../../../api/ke-hoach/keHoachNamApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IKehoachNam } from "../../../model/respone/ke-hoach/IKehoachNam";
import { eKeHoachNamActionIds, IKeHoachNamActionTypes } from "../../action-types/ke-hoach/IKeHoachNamActions";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
const mainAction = rootActions.keHoach.keHoachNam;

export function* keHoachNamSaga(): any {
  yield takeEvery(eKeHoachNamActionIds.LOAD_START, loadWorker);
  yield takeEvery(eKeHoachNamActionIds.SAVE_START, saveWorker)
  yield takeEvery(eKeHoachNamActionIds.DELETE_START, deleteWorker)
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(keHoachNamApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.keHoach.keHoachNam.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.keHoach.keHoachNam.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IKeHoachNamActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IKehoachNam
  if (payload.id_kh > 0) {
    res = yield call(keHoachNamApi.Update, payload)
  } else {
    res = yield call(keHoachNamApi.Insert, payload)
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data))
  } else {
    yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
  }
}

function* deleteWorker(action: IKeHoachNamActionTypes): any {
  const res: IBaseRespone = yield call(keHoachNamApi.Deletes, action.payload as IIdsRequest)
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data))
  } else {
    yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
  }
}